import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useFilterUserOptions = () => {
  const users = useSelector((state) => state.projects.filterUsers);

  return useMemo(() => users.map((user) => ({ value: user.username, label: user.name })), [users]);
};

export default useFilterUserOptions;
